import type { PresenceState } from '../../domain/types'
import type { Realtime } from '../../realtime/Realtime'
import type { RealtimeEvent } from '../../realtime/events'

export class CompositeRealtime implements Realtime {
  constructor(private delegates: Realtime[]) {}

  start(): void {
    this.delegates.forEach((delegate) => delegate.start())
  }

  stop(): void {
    this.delegates.forEach((delegate) => delegate.stop())
  }

  on(cb: (e: RealtimeEvent) => void): () => void {
    const offs = this.delegates.map((delegate) => delegate.on(cb))
    return () => offs.forEach((off) => off())
  }

  presenceOf(ticketIdOrAggId: string | number): PresenceState {
    for (const delegate of this.delegates) {
      const state = delegate.presenceOf(ticketIdOrAggId)
      if (state !== 'offline') {return state}
    }
    return 'offline'
  }

  watchServiceConfig(scid: number): void {
    this.delegates.forEach((delegate) => delegate.watchServiceConfig?.(scid))
  }

  watchChannels(
    serviceConfigIds: number[],
    sessionIds: number[],
    aggregatorIds?: string[],
    ticketIds?: number[]
  ): void {
    this.delegates.forEach((delegate) =>
      delegate.watchChannels?.(serviceConfigIds, sessionIds, aggregatorIds, ticketIds)
    )
  }
}
